import { useState } from 'react';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import strings from 'strings';

import { FEATURE_FLAGS_MAP } from './ClaimAccountability.constants';

/**
 * @param {Object} props
 * @param {('candidate'|'joborder'|'company')} props.entity
 * @param {boolean} [props.isAlreadyAccountable]
 */
export const useClaimAccountability = ({ entity, isAlreadyAccountable }) => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const [openClaimAccountabilityDrawer, setOpenClaimAccountabilityDrawer] = useState(false);

  const isAccountabilityClaimingEnabled = checkIfFeatureFlagEnabled(FEATURE_FLAGS_MAP[entity]);

  const handleOpenClaimAccountabilityDrawer = () => {
    if (!isAccountabilityClaimingEnabled) return;
    setOpenClaimAccountabilityDrawer(true);
  };

  const handleCloseClaimAccountabilityDrawer = () => {
    setOpenClaimAccountabilityDrawer(false);
  };

  const handleSuccessClaimAccountability = () => {
    handleCloseClaimAccountabilityDrawer();
  };

  const claimAccountabilityMenuItem = {
    title: strings.inventoryProfiles.accountability.action,
    action: handleOpenClaimAccountabilityDrawer,
    visible: isAccountabilityClaimingEnabled && !isAlreadyAccountable
  };

  return {
    claimAccountabilityMenuItem,
    handleCloseClaimAccountabilityDrawer,
    handleSuccessClaimAccountability,
    openClaimAccountabilityDrawer
  };
};
